(() => {
  const readySelector = '[data-waiiqi-card-action]';
  let pending = null;

  const placementFor = (card) => {
    if (card.closest('.collection-grid-section')) return 'collection_grid';
    if (card.closest('[id*="recently-viewed"], recently-viewed-products')) return 'recently_viewed';
    return 'product_card';
  };

  const detailsFor = (action) => {
    const card = action.closest(readySelector);
    return {
      product_handle: action.dataset.productHandle || card?.dataset.productHandle || '',
      product_title: action.dataset.productTitle || card?.dataset.productTitle || '',
      variant_id: action.dataset.variantId || '',
      collection_handle: action.dataset.collectionHandle || card?.dataset.collectionHandle || '',
      locale: action.dataset.locale || document.documentElement.lang || 'en',
      product_kind: card?.dataset.productKind || '',
      placement: card ? placementFor(card) : 'product_card',
      path: window.location.pathname
    };
  };

  const publish = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
    document.dispatchEvent(new CustomEvent(name, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name.replace(':', '_'), ...detail });
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(name.replace(':', '_'), detail);
      }
    } catch (_) {}
  };

  const markReady = (root = document) => {
    root.querySelectorAll?.(readySelector).forEach((card) => {
      card.dataset.ready = 'true';
    });
    if (root.matches?.(readySelector)) root.dataset.ready = 'true';
  };

  document.addEventListener('click', (event) => {
    const action = event.target.closest?.('[data-waiiqi-smart-quick-add], [data-waiiqi-smart-choose]');
    if (!action) return;
    const detail = detailsFor(action);
    if (action.matches('[data-waiiqi-smart-quick-add]')) {
      pending = { ...detail, started_at: Date.now() };
      publish('waiiqi:collection_quick_add_clicked', detail);
    } else {
      publish('waiiqi:collection_choose_options_clicked', detail);
    }
  }, true);

  document.addEventListener('ajaxProduct:added', () => {
    if (!pending) return;
    const detail = { ...pending, elapsed_ms: Date.now() - pending.started_at };
    delete detail.started_at;
    publish('waiiqi:collection_quick_add_succeeded', detail);
    pending = null;
  });

  document.addEventListener('ajaxProduct:error', (event) => {
    if (!pending) return;
    const detail = {
      ...pending,
      elapsed_ms: Date.now() - pending.started_at,
      error: event.detail?.errorMessage || 'unknown'
    };
    delete detail.started_at;
    publish('waiiqi:collection_quick_add_failed', detail);
    pending = null;
  });

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) markReady(node);
    }));
  });

  markReady();
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
